(function iife() {
	"use strict";

	angular.module("dx.webapp.integrations").component("dxSamlIntegrations", {
		templateUrl: "tmpl/integrations/saml-integrations-component.html",
		controller: "DxSAMLIntegrationsController",
		controllerAs: "vm",
		bindings: {
			nodeId: "<",
			nodeUnitId: "=",
		},
	});
}());
